import $ from 'jquery'
import manager from '../manager'
import { getParams } from '@/utils/urlQuery'
import http from '@/utils/http'
import querystring from 'querystring'
import { INTERFACE } from '@/utils/INTERFACE'
import Cookies from 'js-cookie'
import { getSite } from '@/utils/site'
import {getCurrency} from '@/utils/currency'

const arriveIdMap={
	US:2456,
	ES:2427,
	RU:2285,
}

manager.add('goodsSearch', {
	async created(defaultSort) {
		var Handlebars=(await import('@/lib/handlebars')).default
		var query = getParams()
		var tpl = $(this.dom).find(".hbs-template").html()
		var tplFn = Handlebars.compile(tpl)
		var orderBy = query.orderBy || defaultSort
		query = { ...query, orderBy }
		var direction = query.direction == '0' ? 0 : 1
		var _direction = direction == 1 ? 0 : 1
		var res = {}
		var arriveId=arriveIdMap[getSite()]
		try{
			arriveId=JSON.parse(Cookies.get("eptCountry")).id
		}catch(err){
			//
		}
		try{
			res=await http.jsonp.get(INTERFACE().shopGoods, {
				pageSize: 16,
				siteFlag: getSite(),
				venderId: $("#J_venderId").val(),
				direction,
				arriveId,
				currency:getCurrency(),
				...query,
			})
		}catch(err){
			console.warn("店内搜索模块数据获取错误")
		}
		var data = res.productResult||{}
		const getLink = param => ("?" + querystring.stringify({ ...query, ...param }))
		var sort = [
			{ text: "Best match", active: orderBy == 0, link: getLink({ orderBy: 0, direction }) },
			{ text: "Popular", active: orderBy == 5, link: getLink({ orderBy: 5, direction: orderBy == 5 ? _direction : direction }) },
			{ text: "Latest", active: orderBy == 1, link: getLink({ orderBy: 1, direction: orderBy == 1 ? _direction : direction }) },
			{ text: "Price", active: orderBy == 4, link: getLink({ orderBy: 4, direction: orderBy == 4 ? _direction : direction }) },
		]
		var paging = []
		if (!data.pageCount){
			console.warn("店内搜索模块数据获取错误")
		}else if(data.currentPageNo < 3) {
			paging = Array(data.pageCount).slice(0,3).fill().map((v, i) => i + 1)
		} else if (data.currentPageNo > data.pageCount - 1) {
			paging = [data.pageCount - 2, data.pageCount - 1, data.pageCount]
		} else {
			paging = [data.currentPageNo - 1, data.currentPageNo, data.currentPageNo + 1]
		}
		paging = paging.map(i => ({
			active: i == data.currentPageNo,
			text: i,
			link: getLink({ pageNo: i })
		}))
		$(this.dom).find(".search-result").html(tplFn({
			list: data.list,
			total: data.totalCount||0,
			sort,
			paging,
			keyword: query.keyword || "",
			isNull: !paging.length,
			direct: direction,
			leftLink: getLink({ pageNo: (data.currentPageNo - 1) > 0 ? (data.currentPageNo - 1) : 1 }),
			rightLink: getLink({ pageNo: (data.currentPageNo + 1) < data.pageCount ? (data.currentPageNo + 1) : data.pageCount })
		}))
		if ($(this.dom).find(".search-result")[0]) {
			this.transDom($(this.dom).find(".search-result")[0])
		}
	}
})



// orderBy :   0、 相关度  5、 销量 1、销售时间 4、价格
manager.add('mGoodsSearch', {
	async created(defaultSort) {
		var Handlebars=(await import('@/lib/handlebars')).default
		var tpl = $(this.dom).find(".hbs-template").html()
		this.tplFn = Handlebars.compile(tpl)
		this.currentPageNo = 1
		this.pageCount = 1
		this.orderBy = defaultSort
		this.sortMap = {
			0: { id: 0, direction: 1 },
			1: { id: 5, direction: 1 },
			2: { id: 1, direction: 1 },
			3: { id: 4, direction: 0 },
		}
		$(this.dom).find(".sort-panel li").on("click", e => {
			var i = $(e.currentTarget).index()
			this.currentPageNo = 1
			if (this.orderBy == this.sortMap[i].id) {
				this.sortMap[i].direction = !this.sortMap[i].direction
			}
			this.orderBy = this.sortMap[i].id
			this.loadPage(this.currentPageNo, true)
		})
		await this.loadPage(this.currentPageNo)
		this.runScroll()
	},
	destroyed() {
		$(this.dom).find(".sort-panel li").off("click")
		$(window).off("scroll", this.scrollHandler)
	},
	runScroll() {
		var timer
		var lock = false
		this.scrollHandler = e => {
			var scrollTop = $(e.currentTarget).scrollTop();
			var scrollHeight = $(document).height();
			var windowHeight = $(e.currentTarget).height();
			if (scrollTop + windowHeight + 20 < scrollHeight) {
				return
			}
			if (this.currentPageNo >= this.pageCount) {
				return
			}
			if (lock) {
				return
			}
			if (timer) {
				clearTimeout(timer)
			}
			timer = setTimeout(async () => {
				lock = true
				await this.loadPage(this.currentPageNo + 1)
				lock = false
			}, 20)
		}
		$(window).on("scroll", this.scrollHandler)
	},
	async loadPage(i, clear) {
		$(this.dom).find(".sort-panel li .text").removeClass("active").removeClass("down")
		var direction = 0
		for (let j in this.sortMap) {
			if (this.orderBy == this.sortMap[j].id) {
				$(this.dom).find(".sort-panel li").eq(j).find(".text").addClass("active")
				if (this.sortMap[j].direction == 1) {
					direction = 1
					$(this.dom).find(".sort-panel li").eq(j).find(".text").addClass("down")
				}
			}
		}
		if (clear) {
			let base = $(this.dom).find(".search-result").offset().top - $(this.dom).find(".sort-panel").height()
			if (base < $(window).scrollTop()) {
				$(window).scrollTop(base + 1)
			}
			$(this.dom).css("min-height", $(this.dom).height())
			$(this.dom).find(".search-result").empty()
		}
		$(this.dom).find(".loading").show()
		var arriveId=arriveIdMap[getSite()]
		try{
			arriveId=Cookies.get("dest_country")||arriveId
		}catch(err){
			//
		}
		var res = {}
		try{
			res=await http.jsonp.get(INTERFACE().shopGoods, {
				pageSize: 16,
				siteFlag: getSite(),
				venderId: $("#J_venderId").val(),
				orderBy: this.orderBy,
				direction,
				arriveId,
				currency:getCurrency(),
				pageNo: i
			})
		}catch(err){
			console.warn("店内搜索模块数据获取错误")
		}
		var data = res.productResult||{}
		if (!data.totalCount) {
			$(this.dom).find(".search-result").hide()
			$(this.dom).find(".blank").show()
		} else {
			$(this.dom).find(".search-result").show()
			$(this.dom).find(".blank").hide()
		}
		var arr = $(this.tplFn({
			list: data.list,
			total: data.totalCount,
			orderBy: this.orderBy,
			isDown: this.isDown,
		})).get().filter(it => it.nodeName != "#text")
		await Promise.all(arr.map(it => this.transDom(it)))
		$(this.dom).find(".loading").hide()
		arr.forEach(it => $(this.dom).find(".search-result").append(it))
		$(this.dom).css("min-height", "")
		this.currentPageNo = data.currentPageNo
		this.pageCount = data.pageCount
	}
})
